// Add/Change Password - Uses Rails backend (not Firebase)
document.addEventListener('turbo:load', () => {
  const addPasswordBtn = document.getElementById('add-password-btn');
  const changePasswordBtn = document.getElementById('change-password-btn');
  const modal = document.getElementById('add-password-modal');
  const cancelBtn = document.getElementById('cancel-password-btn');
  const addPasswordForm = document.getElementById('add-password-form');
  const errorDiv = document.getElementById('password-error');
  const successDiv = document.getElementById('password-success');

  // Check user's password status from data attribute
  function checkUserPasswordStatus() {
    const hasPasswordSection = document.getElementById('has-password-section');
    const noPasswordSection = document.getElementById('no-password-section');
    const noPasswordWarning = document.getElementById('no-password-warning');
    
    // Get password status from body data attribute (set by Rails)
    const hasPassword = document.body.dataset.userHasPassword === 'true';
    
    if (hasPassword) {
      hasPasswordSection?.classList.remove('hidden');
      noPasswordSection?.classList.add('hidden');
      noPasswordWarning?.classList.add('hidden');
    } else {
      hasPasswordSection?.classList.add('hidden');
      noPasswordSection?.classList.remove('hidden');
      noPasswordWarning?.classList.remove('hidden');
    }
  }

  // Run on page load
  checkUserPasswordStatus();

  if (addPasswordBtn) {
    addPasswordBtn.addEventListener('click', () => {
      modal.classList.remove('hidden');
      document.getElementById('modal-title').textContent = window.I18n?.['settings.password_modal.add_title'] || 'Add Password';
      document.getElementById('submit-password-text').textContent = window.I18n?.['settings.security.add_password'] || 'Add Password';
    });
  }

  if (changePasswordBtn) {
    changePasswordBtn.addEventListener('click', () => {
      modal.classList.remove('hidden');
      document.getElementById('modal-title').textContent = window.I18n?.['settings.password_modal.change_title'] || 'Change Password';
      document.getElementById('submit-password-text').textContent = window.I18n?.['settings.security.change_password'] || 'Change Password';
    });
  }

  if (cancelBtn) {
    cancelBtn.addEventListener('click', () => {
      modal.classList.add('hidden');
      addPasswordForm?.reset();
      hideMessages();
    });
  }

  if (addPasswordForm) {
    addPasswordForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      showLoading(true);
      hideMessages();

      const newPassword = document.getElementById('new-password').value;
      const confirmPassword = document.getElementById('confirm-password').value;

      if (newPassword.length < 6) {
        showLoading(false);
        showError(window.I18n?.['auth.errors.weak_password'] || 'Password must be at least 6 characters');
        return;
      }

      if (newPassword !== confirmPassword) {
        showLoading(false);
        showError(window.I18n?.['auth.errors.passwords_dont_match'] || 'Passwords do not match');
        return;
      }

      try {
        const locale = window.location.pathname.split('/')[1] || 'el';
        const url = locale === 'en' ? '/en/settings/add-password' : '/settings/add-password';
        
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          },
          body: JSON.stringify({
            password: newPassword,
            password_confirmation: confirmPassword
          })
        });

        const data = await response.json();

        if (response.ok && data.success) {
          showSuccess(data.message || window.I18n?.['settings.password_modal.success'] || 'Password added successfully!');
          
          // Update UI to show password is set
          document.body.dataset.userHasPassword = 'true';
          
          setTimeout(() => {
            modal.classList.add('hidden');
            addPasswordForm.reset();
            hideMessages();
            checkUserPasswordStatus();
          }, 1500);
        } else {
          showError(data.error || window.I18n?.['auth.errors.auth_failed'] || 'Failed to add password. Please try again.');
        }
      } catch (error) {
        console.error('Password error:', error);
        showError(window.I18n?.['auth.errors.auth_failed'] || 'Failed to add password. Please try again.');
      } finally {
        showLoading(false);
      }
    });
  }

  function showError(message) {
    if (errorDiv) {
      errorDiv.textContent = message;
      errorDiv.classList.remove('hidden');
    }
  }

  function showSuccess(message) {
    if (successDiv) {
      successDiv.textContent = message;
      successDiv.classList.remove('hidden');
    }
  }

  function hideMessages() {
    errorDiv?.classList.add('hidden');
    successDiv?.classList.add('hidden');
  }

  function showLoading(loading) {
    const btnText = document.getElementById('submit-password-text');
    const btnLoading = document.getElementById('add-password-loading');
    
    if (loading) {
      btnText?.classList.add('hidden');
      btnLoading?.classList.remove('hidden');
    } else {
      btnText?.classList.remove('hidden');
      btnLoading?.classList.add('hidden');
    }
  }
});
